module.exports = __webpack_public_path__ + "static/img/CRW_1453-1080p.a4dbe63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio3/CRW_1453-1080p.jpg
// module id = aK8i
// module chunks = 0